import type { FunctionalComponent } from 'preact';

import { cnBubble } from '../bubble.constants.js';

import './bubble__icon.css';

export const BubbleIcon: FunctionalComponent = () => (
    <svg className={cnBubble('icon')} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path
            d="M3.611 9.358h3.82l-1.974 5.08c-.316.8.525 1.226 1.068.583l6.213-7.35a.732.732 0 0 0 .198-.486c0-.32-.25-.548-.578-.548H8.54l1.973-5.075c.31-.8-.525-1.226-1.068-.583l-6.219 7.35a.704.704 0 0 0-.193.486c0 .32.246.543.578.543Z"
            fill="currentColor"
        />
    </svg>
);
